import {
  useElements,
  useStripe as useStripeElements,
} from '@stripe/react-stripe-js';
import { useCheckoutModalStore } from '@sunrise-ui/primitives';
import * as Linking from 'expo-linking';
import { usePathname } from 'expo-router';

export const useStripe = () => {
  const stripe = useStripeElements();
  const elements = useElements();
  const pathname = usePathname();
  const { checkoutId, eventId } = useCheckoutModalStore();

  return {
    confirmPayment: async () => {
      if (!stripe || !elements) {
        return { error: { message: 'Stripe not initialized' } };
      }

      if (!eventId || !checkoutId) {
        return { error: { message: 'Missing event information' } };
      }

      try {
        const { error: submitError } = await elements.submit();
        if (submitError) {
          return { error: submitError };
        }

        const returnUrl = Linking.createURL(pathname, {
          queryParams: {
            checkoutId,
            eventId,
          },
        });

        // Confirm payment - Stripe handles authentication automatically
        // redirect: 'if_required' handles 3DS inline without page redirect
        const { error, paymentIntent } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: returnUrl,
          },
          redirect: 'if_required',
        });

        return { error, paymentIntent };
      } catch (error) {
        const errorMessage =
          error instanceof Error
            ? error.message
            : 'Payment confirmation failed';
        return { error: { message: errorMessage } };
      }
    },
  };
};
